import { FC } from 'react';
import { Tag, Tooltip } from 'antd';
import { UploadTask_Status, UploadTask_ModelUtil } from '~/common/typescript/models/UploadTask';
import { CheckCircleOutlined, ClockCircleOutlined, ExclamationCircleOutlined, SyncOutlined } from '@ant-design/icons';

interface UploadTaskStatusTagProps {
  status: UploadTask_Status;
  hideLabel?: boolean;
}

const getStatusIcon = (status: UploadTask_Status) => {
  switch (status) {
    case UploadTask_Status.PENDING:
      return <ClockCircleOutlined />;
    case UploadTask_Status.PROCESSING:
      return <SyncOutlined spin />;
    case UploadTask_Status.SUCCESS:
      return <CheckCircleOutlined />;
    case UploadTask_Status.FAILED:
      return <ExclamationCircleOutlined />;
    default:
      return null;
  }
};

const UploadTaskStatusTag: FC<UploadTaskStatusTagProps> = ({ status, hideLabel }) => {
  const isSuccessOrFailed =
    status === UploadTask_Status.SUCCESS || status === UploadTask_Status.FAILED;
  const showText = !hideLabel && !isSuccessOrFailed;
  const text = UploadTask_ModelUtil.getTextStatus(status);

  return (
    <Tooltip title={text}>
      <Tag
        icon={getStatusIcon(status)}
        color={UploadTask_ModelUtil.getStatusColor(status)}
        style={{
          fontSize: '11px',
          padding: showText ? '1px 5px' : '1px 4px',
          marginInlineEnd: 0,
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {showText ? text : null}
      </Tag>
    </Tooltip>
  );
};

export default UploadTaskStatusTag;
